import "./Joystickb.css";
import { stateTouchCircleLook } from "../store";
import { stateDevice } from "../store";
import { useSnapshot } from "valtio";
import { useEffect } from "react";
import { useState } from "react";

import { Joystick } from "react-joystick-component";


// var joySize = 150
// var joysizeThumb = 70


export default function JoystickLook() {

  const [joySize, setjoySize] = useState()
  const [joysizeThumb, setjoysizeThumb] = useState()


  const snapIsMobile = useSnapshot(stateDevice)
  useEffect(()=>{
    if (snapIsMobile.isMobile  && !snapIsMobile.isTablet)
    {
      setjoySize(100)
      setjoysizeThumb(40)

    }
    else{
      setjoySize(150)
      setjoysizeThumb(70)
    }
    
      },[snapIsMobile.isMobile])



  // Neutral-Offset für die Vertikale: bestimmt, auf welcher Höhe die
  // Orbit-Kamera beim ersten Antippen startet. -1.2 entspricht ungefähr der
  // Elevation der Follow-Kamera (Player.jsx: verticalAngle = y * PI/3,
  // Follow-Offset (0,35,-45) ≈ -1.25 rad) — so springt der Blick beim
  // Berühren des Sticks nicht mehr (vorher -0.75 = ~45° Sprung nach oben).
  const NEUTRAL_Y = -1.2;

  const handleMove = (e) => {
    stateTouchCircleLook.x = e.x *  0.5;
    stateTouchCircleLook.y = - e.y  + NEUTRAL_Y
    stateTouchCircleLook.OrbitOn = true
    stateTouchCircleLook.JoystickLookOn = true
  };
  const handleStop = (e) => {
 
    
    stateTouchCircleLook.x = 0;
    stateTouchCircleLook.y = 0;
    stateTouchCircleLook.OrbitOn = false

  };

 
  return (
    <div className="joystickRight" >
    
      <Joystick
        size={joySize}
        baseColor="red"
        stickColor="blue"
        stickSize={joysizeThumb}
        move={handleMove}
        stop={handleStop}
        baseImage="./UI/JoystickBackground.png"
        stickImage="./UI/JoystickThumb.png"
      // throttle = {300}
      />
    </div>
  );
}
